import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Card,
  CardContent,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface User {
  id: number;
  name: string;
  email: string;
}

interface Team {
  id: number;
  name: string;
  users: User[];
  totalCredits: number; // Added these fields for modal example
  percentage: number;
}

interface Props {
  teams: Team[];
}

const TeamList = ({ teams }: Props) => {
  
  return (
    <Card
      key="teamList"
      sx={{
        ml: 2,
        mr: 1,
        mt: 1,
        mb: 1,
        width: '50%',
        overflow: 'visible',
        background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.95) 0%, rgba(101, 67, 33, 0.92) 100%)',
        backdropFilter: 'blur(10px)',
        border: '0.2rem solid rgba(218, 165, 32, 0.7)',
        borderRadius: '1rem',
        boxShadow: '0 0.5rem 1.5rem rgba(0, 0, 0, 0.5), 0 0 1rem rgba(218, 165, 32, 0.4)',
      }}
      variant="outlined"
    >
      <CardContent>
        <Box>
          <Typography variant="h6" sx={{
            fontFamily: "'Cinzel', serif",
            color: '#FFD700',
            fontWeight: 700,
            textShadow: '0.15rem 0.15rem 0.3rem rgba(0,0,0,0.9), 0 0 0.8rem rgba(255, 215, 0, 0.6)',
            mb: 2,
          }}>Users</Typography>
          <Box display="flex" flexDirection="column">
            {teams.map((team) => (
              <Accordion key={team.id} sx={{
                background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.3) 0%, rgba(101, 67, 33, 0.25) 100%)',
                border: '0.1rem solid rgba(218, 165, 32, 0.5)',
                borderRadius: '0.5rem !important',
                mb: 1,
                '&:before': {
                  display: 'none',
                },
              }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#FFD700' }} />} sx={{
                  '& .MuiAccordionSummary-content': {
                    margin: '0.75rem 0',
                  },
                }}>
                  <Typography variant="body1" sx={{
                    fontFamily: "'Philosopher', sans-serif",
                    color: '#FFD700',
                    fontWeight: 600,
                    textShadow: '0.1rem 0.1rem 0.2rem rgba(0,0,0,0.8)',
                  }}>{team.name}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 1, background: 'rgba(20, 20, 40, 0.3)' }}>
                  {team.users.length > 0 ? (
                    <TableContainer>
                      <Table>
                        <TableBody>
                          {team.users.map((user) => (
                            <TableRow key={user.id} sx={{
                              '&:hover': {
                                background: 'rgba(218, 165, 32, 0.15)',
                              }
                            }}>
                              <TableCell sx={{
                                border: 'none',
                                p: 0.5,
                                color: '#FFA500',
                                fontFamily: "'Philosopher', sans-serif",
                              }}>
                                <Typography variant="body2">{user.name}</Typography>
                              </TableCell>
                              <TableCell sx={{
                                border: 'none',
                                p: 0.5,
                                color: '#FFA500',
                                fontFamily: "'Philosopher', sans-serif",
                              }}>
                                <Typography variant="body2">{user.email}</Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <Typography variant="body2" sx={{
                      color: 'rgba(255, 165, 0, 0.7)',
                      fontFamily: "'Philosopher', sans-serif",
                    }}>
                      No users in this team.
                    </Typography>
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TeamList;
